<template>
  <div class="SolutionAdd_box">
    <div class="isFlex">
      <div class="me-write-info">文章标题</div>
      <div class="me-write-title" style="margin-left: 15px">
        <el-input v-model="articleForm.solutionTitle" placeholder="请输入文章标题" class="me-write-input" autofocus style="border-radius: 30px; line-height: 53px">
        </el-input>
      </div>
    </div>

    <div class="flex-align-items">
      <div class="me-write-info">分类板块</div>
      <div class="me-write-title" style="margin-left: 15px">
        <el-select style="width: 400px" v-model="articleForm.solutionCategoryId" value-key="id" placeholder="请选择分类板块">
          <el-option v-for="c in categorys" :key="c.id" :label="c.solutionName" :value="c.id">
          </el-option>
        </el-select>
        <span style="color:#d32f2f;font-size:14px;margin-left:15px">* 每个板块只可发布一篇文章</span>
      </div>
    </div>

    <!-- 富文本编辑 -->
    <el-container class="me-area">
      <el-main class="me-write-main">
        <div id="editorBox"></div>
      </el-main>
    </el-container>

    <!-- 发表 -->
    <div class="fixedBtnWrap flex-right">
      <div class="flexWrap">
        <div class="btnFBarticle m-r-20" @click="releaseSolutionFn()">
          <span>发布方案</span>
        </div>
      </div>
    </div>

    <!-- 发布弹窗 -->
    <el-dialog title="发布" :visible.sync="releaseSolutionDialog" :close-on-click-modal="false" width="800px" v-dialogDrag>
      <div class="setArticleInfo" id="setArticleInfo">
        <el-form :model="articleForm" ref="articleForm" :rules="rules">
          <el-form-item prop="summary" label="摘要信息">
            <el-input type="textarea" maxlength='300' v-model="summaryValue" :rows="2" placeholder="请输入文章摘要">
            </el-input>
            <div class="wordTip">{{inputedNum}}/300</div>
          </el-form-item>

          <el-form-item label="分类板块" prop="solutionCategoryId">
            <el-select style="width: 400px" v-model="articleForm.solutionCategoryId" value-key="id" placeholder="请选择分类板块">
              <el-option v-for="c in categorys" :key="c.id" :label="c.solutionName" :value="c.id">
              </el-option>
            </el-select>
          </el-form-item>

          <!--          <el-form-item label="展示封面" style="margin-left: 10px;">-->
          <!--            <span style="color: #b00000;font-size: 12px;">(*建议封面图片上传尺寸为180*130)</span>-->
          <!--            <el-upload class="avatar-uploader" accept='image/*' :action="this.$const.common.fileUpload"-->
          <!--                       :show-file-list="false"-->
          <!--                       name="article_img"-->
          <!--                       :before-upload="beforeAvatarUpload"-->
          <!--                       :on-success="handleAvatarSuccess" :headers="myHeaders">-->
          <!--              <img v-if="imageUrl" :src="imageUrl" class="avatar"/>-->
          <!--              <img v-else-if="articleForm.imageUrl" :src="URLimg + articleForm.imageUrl" class="avatar"/>-->
          <!--              <i v-else class="el-icon-plus avatar-uploader-icon"></i>-->
          <!--            </el-upload>-->
          <!--          </el-form-item>-->
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="releaseSolutionDialog = false">取 消</el-button>
        <el-button type="primary" @click="publish('articleForm')">发布</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  import E from 'wangeditor';
  import hljs from 'highlight.js'
  import { getToken, getXapp, getUUID, getIsStage } from './config';
  import functionCom from '@/utils/function';

  export default {
    name: "SolutionAdd",
    // import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
      return {
        content: null, //输入内容
        textContent: "", //纯文本
        categorys: [],
        imageUrl: "",
        tags: [],
        myHeaders: {
          'Authorization': getToken(),
          "x-app": getXapp(),
          'x-api': this.$const.common.fileUpload,
          'x-gw-version': 2,
          'x-ts': new Date().getTime(),
          'x-nonce': getUUID(),
          'x-client': 'WEB',
          'x-stage': getIsStage(),
          'x-did': '',
          'x-app-version': '',
          'x-sign': '',
          'x-sign-headers': '',
          'x-token': getToken()
        },
        myVideoHaders: {
          'Authorization': getToken(),
          "x-app": getXapp(),
          'x-gw-version': 2,
          'x-ts': new Date().getTime(),
          'x-nonce': getUUID(),
          'x-client': 'WEB',
          'x-stage': getIsStage(),
          'x-did': '',
          'x-app-version': '',
          'x-sign': '',
          'x-sign-headers': '',
          'x-token': getToken()
        },
        coverUrl: window.dataManage.imgUpload,
        URLimg: window.dataManage.imgShowUrl,
        inputedNum: 0, //已输入字数
        summaryValue: '', //摘要内容
        articleForm: {
          id: "",
          solutionTitle: "",
          summary: "",
          solutionCategoryId: '',
          imageUrl: "",
          articleStatus: "",
        },
        rules: {
          summary: [{
            required: true,
            message: "请输入摘要",
            trigger: "blur",
          }],
          solutionCategoryId: [{
            required: true,
            message: "请选择分类板块",
            trigger: "change",
          }, ],
        },
        releaseSolutionDialog: false
      }
    },
    watch: {
      summaryValue: {
        handler: function(val1, val2) {
          // console.log(val1,val2);
          this.inputedNum = val1.length;
          this.articleForm.summary = val1;
        },
        deep: true
      },
    },
    // 创建完成
    created() {
      this.getSolutionCategoryFn();
    },
    mounted() {
      var _this = this;
      const editor = new E('#editorBox');
      // 配置菜单栏，设置不需要的菜单
      editor.config.showFullScreen = false;
      // 设置编辑器高度
      if (document.body.clientWidth > 1400) {
        editor.config.height = 600;
      } else {
        editor.config.height = 500;
      }
      editor.config.onchange = function(e) {
        // console.log(e);
        // console.log(editor.txt.text());
        let sendCont = editor.txt.text();
        if (sendCont.length < 300) {
          _this.summaryValue = sendCont;
        } else {
          _this.summaryValue = sendCont.substring(0, 300);
        }
        _this.content = e;
      };
      // 代码高亮
      editor.highlight = hljs;
      // 一次最多上传 1 个图片
      editor.config.uploadImgMaxLength = 1;
      // 隐藏网络图片入口
      editor.config.showLinkImg = false;
      //圖片上传地址
      editor.config.uploadImgServer = this.$const.common.fileUpload;
      // 图片上传header参数设置
      // editor.config.uploadImgHeaders = _this.myHeaders;
      // 自定义参数名称
      editor.config.uploadFileName = 'file';
      //输入内容-触发时间为500ms每次
      editor.config.onchangeTimeout = 500;
      // 默认限制图片上传大小为5M
      editor.config.uploadImgHooks = {
        customInsert: function(insertImgFn, result) {
          // result 即服务端返回的接口
          // console.log('customInsert', result)
          if (result.code == 200) {
            let imgUrl = result.data;
            // insertImgFn 可把图片插入到编辑器，传入图片 src ，执行函数即可
            insertImgFn(imgUrl);
          }

        }
      };
      editor.config.uploadVideoHeaders = this.myVideoHaders;
      // 配置视频上传地址
      editor.config.uploadVideoServer = this.$const.common.fileUpload;
      editor.config.uploadVideoName = 'file';
      editor.config.uploadVideoHooks = {
				customInsert: function (insertImgFn, result) {
					// result 即服务端返回的接口
					// console.log('customInsert', result)
					if (result.code == 200) {
						let imgUrl = result.data;
						// insertImgFn 可把图片插入到编辑器，传入图片 src ，执行函数即可
						insertImgFn(imgUrl);
					}

				}
			};
      editor.create();
      //如果存在文章id去获取文章信息 否则过
      if (this.$route.query.id) {
        this.$http.get(this.$const.SellerCenter.solutionGetOne + this.$route.query.id)
          .then((data) => {
            console.log(data);
            if (!data.data.solutionContent) {
              _this.$message({
                message: this.$PubText.errorCom,
                type: "warning",
                showClose: true,
              });
              setTimeout(function() {
                _this.$router.push('/');
              }, 1000);
              return false;
            } else {
              Object.assign(_this.articleForm, data.data);
              this.summaryValue = this.articleForm.summary;
              _this.content = data.data.solutionContent;
              editor.txt.html(_this.content);
              // $('#editorBox').html(that.content);
              // 已选分类信息和标签集合 插入数据回显
              _this.articleForm.category = _this.articleForm.solutionCategoryId;
              console.log("待修改的文章信息", this.articleForm);
            }
          })
          .catch((error) => {
            console.log(error, '文章加载失败')
          });

      }
    },
    // 方法集合
    methods: {
      /**
       * @name: 获取解决方案分类列表
       * @description：solutionCategory
       * @author: king
       * @time：2022-10-12 19:08:16
       *
       */
      async getSolutionCategoryFn() {
        try {
          let res = await this.$http.post(this.$const.SellerCenter.solutionCategory);
          if (res && res.data) {
            console.log(res);
            this.categorys = res.data;
          }
        } catch (e) {
          // console.log(e);
        }
      },
      // 发布文章
      handleAvatarSuccess(res, file) {
        this.imageUrl = URL.createObjectURL(file.raw);
        this.articleForm.imageUrl = res.data.imgUrl;
      },
      beforeAvatarUpload(file) {
        functionCom.beforeAvatarUpload(file);
      },
      releaseSolutionFn() {
        if (!this.articleForm.solutionTitle) {
          this.$message({
            message: "请先填写标题",
            type: "warning",
            showClose: true,
          });
          return;
        }
        if (!this.articleForm.solutionCategoryId) {
          this.$message({
            message: "请选择分类板块",
            type: "warning",
            showClose: true,
          });
          return;
        }
        if (!this.content) {
          this.$message({
            message: "请先填写内容",
            type: "warning",
            showClose: true,
          });
          return;
        }
        if (!this.summaryValue) {
          this.$message({
            message: "请对内容进行简单描述",
            type: "warning",
            showClose: true,
          });
          return;
        }
        this.publish();
      },
      /**
       * @name: 保存解决方案
       * @description：solutionAdd
       * @author: king
       * @time：2022-10-12 19:40:42
       */
      async publish() {
        let params = {
          solutionCategoryId: this.articleForm.solutionCategoryId,
          solutionContent: this.content,
          solutionTitle: this.articleForm.solutionTitle,
        };
        // let loading = this.$loading({
        //   lock: true,
        //   text: "发布中...",
        // });
        let res = '';
        try {
          if (this.$route.query.id) {
            // 修改
            params.id = this.$route.query.id;
            res = await this.$http.put(this.$const.SellerCenter.solutionUpdate, params);
          } else {
            res = await this.$http.post(this.$const.SellerCenter.solutionAdd, params);
          }
          if (res && res.data) {
            await this.$message.success(this.$PubText.successCom);
            await this.$router.push({
              path: 'SellerCenter',
              query: {
                type: 'SolutionList'
              }
            });
          }
        } catch (e) {
          console.log(e);
        }

        // this.$refs[articleForm].validate(async (valid) => {
        //   if (valid) {
        //   }
        // });
      }
    }
  }
</script>

<style lang="scss" scoped>
  .SolutionAdd_box {
    position: relative;

    #editorBox {
      margin: 25px auto;
      border-radius: 8px;
      background-color: #ffffff;
      padding: 10px;
      box-sizing: border-box;
      z-index: 197 !important;
      position: relative;
    }

    .me-write-info {
      font-size: 17px;
      color: #525252;
      line-height: 53px;
    }

    .me-write-title {
      flex: 1;
    }

    .fixedBtnWrap {
      position: fixed;
      z-index: 200;
      bottom: 20px;
      width: 1300px;
      height: 60px;

      .btnCG {
        background: #ffffff;
        cursor: pointer;
        padding: 8px 24px;
        font-size: 16px;
        color: #999aaa;
        border-radius: 24px;
        white-space: nowrap;
        border: 1px solid #999aaa;
      }

      .flexWrap {


        .btnFBarticle {
          background: #007aff;
          cursor: pointer;
          padding: 8px 24px;
          font-size: 16px;
          color: #fff;
          border-radius: 24px;
          white-space: nowrap;
          border: 1px solid #007aff;
        }


        .btnCancle {
          background: #ffffff;
          cursor: pointer;
          padding: 8px 24px;
          font-size: 16px;
          color: #999aaa;
          border-radius: 24px;
          white-space: nowrap;
          border: 1px solid #999aaa;
        }
      }
    }

    .setArticleInfo {
      width: 100%;
      margin: 0px auto;
      border: 0;
      border-radius: 8px;
      background-color: #ffffff;
      padding: 10px;
      box-sizing: border-box;

      /* box-shadow: 0 0 0 10px #fffff; */
      .wordTip {
        position: absolute;
        right: 1px;
        bottom: 1px;
        line-height: 30px;
        color: #848484;
      }
    }
  }
</style>